import { MolJob } from '@/packages/mol/entities/MolJob';
import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    molJob: new MolJob(),
    presets: null,
};
export var types = {
    SET_MOL_JOB: 'setMolJob',
    SET_PRESETS: 'setPresets',
};
export var mol = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
